<template src="./ButtonRejectComponent.html"></template>
<script>
export default {
  name: 'ButtonRejectComponent',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped></style>
